(function () {
    'use strict';

    /**
     * @ngdoc service
     * 
     *
     * @description
     *
     */
    angular
        .module('fuel')
        .service('FuelUpliftService', FuelUpliftService);

    function FuelUpliftService(CommonFuelService, FuelRequestFactory, RemoteService) {
        var self = this;

         var model={
            searchCriteria: FuelRequestFactory.getFuelUpliftSearchRequest(),
            upliftList:[]
        };

        self.setUpliftSearchCriteria = function (searchCriteria) {
            model.searchCriteria = FuelRequestFactory.getFormattedFuelUpliftSearchRequest(searchCriteria);
        };


        self.getSearchCriteria = function () {
            return model.searchCriteria;
        };

        
        self.refineData = function (refineParam) {
            var filter = {};
            
            if (!angular.isUndefined(refineParam.receipt) && refineParam.receipt !== null && refineParam.receipt !== "") {
                filter['fuelInvoiceNo'] =  refineParam.receipt;
            }
            if (!angular.isUndefined(refineParam.haj) && refineParam.haj !== null) {
                filter['haj'] = refineParam.haj;
            }
            if (!angular.isUndefined(refineParam.airports[0]) && refineParam.airports !== null) {
                filter['origin'] = refineParam.airports[0].airPortCode;
            }
            return _.filter(angular.copy(model.upliftList), filter);
        };
        

        self.getFuelUplift = function(successFn, errorFn){
            RemoteService.searchFuelUplifts(model.searchCriteria).then(
                function (response) {
                    if(response.success){
                        model.upliftList = response.fuelUplifts;
                        successFn(model.upliftList);
                    }
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };

    }
})();